import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/content";

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Voices"
        title="看过的人怎么说"
        desc="口碑来自看得见的画面。以下反馈来自长期观看直播与参与连麦的网友，内容保持原话。"
      />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-10 md:gap-5">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6"
          >
            <div className="flex items-center justify-between gap-3">
              <i className="ri-double-quotes-l text-2xl text-primary-500" aria-hidden="true" />
              <span className="rounded-md bg-secondary-100/80 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                {item.tag}
              </span>
            </div>
            <blockquote className="text-sm leading-relaxed text-foreground-800">
              {item.text}
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 border-t border-background-200/70 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100/60 font-heading text-sm font-bold text-primary-500">
                {item.name.slice(0, 1)}
              </span>
              <span className="flex flex-col">
                <span className="text-[13px] font-medium text-foreground-950">{item.name}</span>
                <span className="text-[11px] text-foreground-500">{item.role}</span>
              </span>
              <span className="ml-auto flex items-center gap-0.5 text-primary-500" aria-label="五星好评">
                <i className="ri-star-fill text-xs" aria-hidden="true" />
                <i className="ri-star-fill text-xs" aria-hidden="true" />
                <i className="ri-star-fill text-xs" aria-hidden="true" />
                <i className="ri-star-fill text-xs" aria-hidden="true" />
                <i className="ri-star-fill text-xs" aria-hidden="true" />
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}